/**
 * Direction detection utilities for RTL/LTR text handling.
 * Used across the app to auto-detect text direction for labels, placeholders, inputs.
 */

/**
 * Returns effective direction reading from document.documentElement.dir.
 * Falls back to "rtl" when dir is not set (Arabic is the primary language).
 * Use in non-React contexts; in React components prefer usePageDirection hook.
 */
export function getEffectiveDir(): "rtl" | "ltr" {
  return document.documentElement.dir === "ltr" ? "ltr" : "rtl";
}

/**
 * Detects if text is RTL based on first strong RTL character.
 * Covers Arabic, Hebrew, Syriac, Thaana, N'Ko, Samaritan, Mandaic, Manichaean,
 * Adlamic, and other RTL scripts.
 */
export function getDirection(text: string): 'rtl' | 'ltr' {
  const rtl = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0590-\u05FF]/;
  return rtl.test(text) ? 'rtl' : 'ltr';
}
